import { ActionReducerMap } from '@ngrx/store';
import { accordionSearchReducer } from './accordionSearch/accordion-search.reducer';
import { AppState } from './app.state';
import { errorReducer } from './errors/error.reducers';
import { directoryReducer } from './directory/directory.reducer';
import { overviewReducer } from './overview/overview.reducer';
import { customReducer } from './custom/custom.reducer';
import { requestsReducer } from './requests/requests.reducer';
import { companiesReducer } from './companies/companies.reducer';
import { fileDetailsReducer } from './file-details/file-details.reducer';
import { referenceReducer } from './reference/reference.reducer';
import { usersReducer } from './users/users.reducer';
import { featureFlagsReducer } from './feature-flags/feature-flags.reducer';

export const appReducers: ActionReducerMap<AppState> = {
  errors: errorReducer,
  search: accordionSearchReducer,
  directory: directoryReducer,
  overview: overviewReducer,
  custom: customReducer,
  requests: requestsReducer,
  companies: companiesReducer,
  fileDetails: fileDetailsReducer,
  reference: referenceReducer,
  users: usersReducer,
  featureFlags: featureFlagsReducer,
};
